
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 18a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V1.5h-4.939l3.22 3.22c.141.141.219.329.219.53s-.078.389-.22.53a.749.749 0 01-1.06 0L15.44 1.5H8.561L1.5 8.56v.879L8.561 16.5h2.689a.75.75 0 010 1.5H.75zm5.689-1.5L1.5 11.56v4.94h4.939zM1.5 6.439L6.439 1.5H1.5v4.939z"}}),_c('path',{attrs:{"d":"M16.176 23.997a1.5 1.5 0 01-1.476-1.769l.736-5.416a5.202 5.202 0 01-1.935-4.062c0-2.895 2.355-5.25 5.25-5.25S24 9.855 24 12.75c0 1.584-.699 3.05-1.926 4.054l.742 5.457c.084.456-.072.947-.419 1.295a1.491 1.491 0 01-1.063.441c-.4 0-.777-.155-1.06-.437l-1.52-1.52-1.519 1.519a1.49 1.49 0 01-1.059.438zm.004-1.534l-.004.037 2.048-2.052a.751.751 0 01.53-.216c.2 0 .394.079.531.216l2.049 2.05-.662-4.865A5.18 5.18 0 0118.75 18a5.162 5.162 0 01-1.913-.364l-.657 4.827zM18.75 9C16.682 9 15 10.682 15 12.75s1.682 3.75 3.75 3.75 3.75-1.682 3.75-3.75S20.818 9 18.75 9z"}}),_c('circle',{attrs:{"cx":"18.75","cy":"12.75","r":"1.125"}})])
          )
        }
      }
    